<template>
  <div id="screeningDataInfo-edit">

    <IForm :label-width="80" ref="formInline" :model="edit" :elem="editElem" :rules="editRule" @on-submit="toSubmit" :submit="false" :showMessage="true">
      <div slot="extend">
        <Row>
          <Col span="12">
            <FormItem label="姓名" prop="name">
              <el-select ref="mySelect" v-model="edit.name" placeholder="请搜索姓名" clearable filterable remote style="width: 100%;"
                         size="small" transfer="true" no-match-text="无数据" no-data-text="无数据" :automatic-dropdown="true"
                         :popper-append-to-body="false" @visible-change="handleArrow"
                         @change="selectStudent($event)" :remote-method="query=>{queryStudent(query)}" @clear="handleClear">
                <el-option v-for="item in options" :key="item.id" :label="item.name + '(' + item.idCard + ')'" empty="无数据" :value="item" style="width: 100%;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="学校"><Input v-model="edit.schoolName" type="text" placeholder="学校" :disabled="disabled"/></FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="年级"><Input v-model="edit.gradeName" type="text" placeholder="年级" :disabled="disabled"/></FormItem>
          </Col>
          <Col span="12">
            <FormItem label="班级"><Input v-model="edit.classesName" type="text" placeholder="班级" :disabled="disabled"/></FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="出生日期"><Input v-model="edit.birthday" type="text" placeholder="出生日期" :disabled="disabled"/></FormItem>
          </Col>
          <Col span="12">
            <FormItem label="证件号码"><Input v-model="edit.idCard" type="text" placeholder="证件号码" :disabled="disabled"/></FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <FormItem label="体检套餐" prop="packagesId">
              <Select v-model="edit.packagesId" style="width: 100%;" @on-change="changePackages">
                <Option v-for="item in packagesLists" :value="item.id" v-bind:key="item.id">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <FormItem label="体检报告">
              <Select v-model="edit.reportTemplateIds" style="width: 100%;" multiple>
                <Option v-for="item in reportTemplates" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <FormItem>
          <EditTabPanel ref="editTabPanel" :show-tabs="['physicalProject', 'lisProject']" :projectIds.sync="edit.projectIds"  :lisProjectIds.sync="edit.lisProjectIds"/>
        </FormItem>
      </div>
    </IForm>

  </div>
</template>
<script>
import {_get, _save} from "@/services/screening/screeningDatainfo";
import { mixins } from "@/mixins/index.js";
import {_studentsList} from "@/services/studentManage/studentManage";
import {_packagesList, _packagesTaskId} from "@/services/screeningConfig/phlysicalPackage";
export default {
  name: "ScreeningDataInfoEdit",
  mixins: [mixins],
  data() {
    return {
      disabled:true,
      edit: {
        id:"",
        studentId:"",
        residentId:"",
        name:"",
        schoolName:"",
        schoolId:"",
        gradeName:"",
        gradeId:"",
        classesName:"",
        classesId:"",
        birthday:"",
        idCard:"",
        packagesId:"",
        reportTemplateId:"",
        projectIds:[],
        lisProjectIds:[]
      },
      options:[],
      packagesLists:[],
      init: "",
      editElem:[],
      editRule: {
        residentId: [
          {required: true, message: '名称不能为空'}
        ],
        packagesId: [
          {required: true, message: "请选择体检套餐"}
        ],
      },
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
    this.fixArrowIcon();
  },
  methods: {
    // 聚焦时显示下拉框
    showDropdown() {
      this.$refs.myAutocomplete.suggestionsVisible = true;
    },
    // 点击箭头切换下拉框
    toggleDropdown() {
      const comp = this.$refs.myAutocomplete;
      comp.suggestionsVisible = !comp.suggestionsVisible;
    },
    // 初始化添加箭头类名
    fixArrowIcon() {
      const iconEl = this.$refs.mySelect.$el.querySelector('.el-input__icon');
      iconEl.classList.add('el-icon-arrow-up');
    },
    // 根据展开状态旋转箭头
    handleArrow(isOpen) {
      const iconEl = this.$refs.mySelect.$el.querySelector('.el-input__icon');
      isOpen ? iconEl.classList.add('is-reverse') : iconEl.classList.remove('is-reverse');
    },
    queryStudent(query, cb){
      this.options = [];
      _studentsList({name: query}).then(res=>{
        if(res.errcode === 1 && res.data){
          let dataList = res.data;
          let tempOptions = [];
          dataList.forEach(item =>{
            this.options.push(item)
            tempOptions.push(item)
          })
          if(cb){
            this.$nextTick(()=>{
              cb(tempOptions);
            })
          }
        }else{
          if(cb) {
            this.$nextTick(() => {
              cb(tempOptions);
            })
          }
        }
      })
    },
    handleClear(){
      this.edit.studentId = "";
      this.edit.name = "";
      this.edit.schoolName = "";
      this.edit.gradeName = "";
      this.edit.classesName = "";
      this.edit.birthday = "";
      this.edit.idCard = "";
      this.studentId = "";
      this.residentId = "";
      this.packagesId = "";
      this.reportTemplateId = "";
      this.projectIds = [];
      this.lisProjectIds = [];
    },
    selectStudent(rowData){
      this.edit.studentId = rowData.studentId;
      this.edit.residentId = rowData.residentId;
      this.edit.name = rowData.name;
      this.edit.schoolName = rowData.schoolName;
      this.edit.schoolId = rowData.schoolId;
      this.edit.gradeName = rowData.gradeName;
      this.edit.gradeId = rowData.gradeId;
      this.edit.classesName = rowData.classesName;
      this.edit.classesId = rowData.classesId;
      this.edit.birthday = rowData.birthday;
      this.edit.idCard = rowData.idCard;
    },
    changePackages(val){
      if(!val){
        return;
      }
      _packagesList({packagesId: val}).then(res=> {
        if (res.errcode === 1) {
          this.edit.projectIds = res.data.projectIds
          this.edit.lisProjectIds = res.data.lisProjectIds
        }
      });
    },
    packagesTaskId(taskId){
      _packagesTaskId({taskId: taskId}).then(res=> {
        if (res.errcode === 1) {
          this.packagesLists = res.data;
        }
      });
    },
    async handleModal(row) {
      this.packagesLists = [];

      await this.applyReportTemplates();
      if(row && row.taskId){
        this.packagesTaskId(row.taskId);
      }else{
        this.packagesLists = await this.applyPackagesName();
      }

      this.$refs["formInline"].handleReset();
      if (!row) {
        // await this.applyStudentsList();
        this.handleCreate();
      } else {
        this.handleEdit(row);
      }
      this.$forceUpdate();
    },
    handleCreate() {
      this.edit = Object.assign({}, this.init);
    },
    handleEdit(row) {
      _get({physicalId: row.physicalId}).then(res => {
        if (res.errcode === 1) {
          this.edit = Object.assign({}, res.data);

          if(this.edit.reportTemplateId){
            this.edit.reportTemplateIds = this.edit.reportTemplateId.toString().split(",");
          }
          this.$forceUpdate();
        }
      })
    },
    handleSubmit() {
      this.$refs["formInline"].handleSubmit('form');
    },
    toSubmit() {
      if(this.edit.reportTemplateIds){
        this.edit.reportTemplateId = this.edit.reportTemplateIds.toString();
      }
      delete this.edit.reportTemplateIds;

      _save(this.edit).then(res => {
        if (res.errcode === 1) {
          this.$message.success("保存成功");
          this.$emit("on-submit", false);
        } else {
          this.$message.error(res.errmsg);
        }
      }).catch(() => {});
    }
  }
};
</script>
<style lang="postcss" scoped>
/deep/.ivu-input[disabled], fieldset[disabled] .ivu-input {
  background-color: #f3f3f38c;
  opacity: 1;
  cursor: not-allowed;
  color: #303133;
}

/deep/.ivu-checkbox-disabled+span {
  background-color: #f3f3f38c;
  opacity: 1;
  cursor: not-allowed;
  color: #303133;
}

/deep/.el-input.is-disabled .el-input__inner {
  background-color: #f3f3f38c;
  opacity: 1;
  cursor: not-allowed;
  color: #303133;
}

/deep/.ivu-select-disabled .ivu-select-selection {
  background-color: #f3f3f38c;
  opacity: 1;
  cursor: not-allowed;
  color: #303133;
}

/deep/.el-select .el-input__suffix .el-icon-arrow-up {
  display: inline-block !important;
}


</style>
